import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { ActionListItem } from 'components/ActionList'
import { List, ListItem } from 'components/List'
import { Modal, ModalFooter, ModalHeader } from 'components/Modal'
import { City } from '../../../../data/models/funnelOrder/cities'
import { AppState } from '../../../../data/state'
import Content from '../../../shared/content'
import ExcludeCities from '../../shared/ExcludeCities'

interface TrainExcludedOptionProps {
  excludedCities: City[]
  max?: number
}

interface TrainExcludedOptionState {
  showModal: boolean
}

class TrainExcludedOption extends React.Component<
  TrainExcludedOptionProps,
  TrainExcludedOptionState
> {
  constructor(props: TrainExcludedOptionProps) {
    super(props)
    this.state = {
      showModal: false,
    }
  }

  public render() {
    return (
      <>
        <ActionListItem
          icon={SRPRS.mapMarkerColored}
          iconProps={{
            width: '37',
            height: '37',
            viewBox: '0 0 37 41',
            fill: 'none',
          }}
          subject={
            <DisplayContent contentKey="exclude-cities-option">
              Exclude Cities
            </DisplayContent>
          }
          value={this.getExcludedCitiesList()}
          onClick={this.toggleModal}
        />
        {this.state.showModal ? (
          <Modal
            size="xl"
            animationType={'1'}
            sticky={true}
            onDismiss={this.toggleModal}
            modalName={`TrainDestinationModal`}
          >
            <ModalHeader
              icon={SRPRS.mapMarkerColored}
              iconProps={{
                width: '37',
                height: '37',
                viewBox: '0 0 37 41',
                fill: 'none',
              }}
            >
              <Content contentKey="destination">TrainDestination</Content>
            </ModalHeader>
            <div className="content">
              <List horizontal={true} borderType={'horizontal-mobile'}>
                <ListItem>
                  <Content contentKey="2-to-4-hours">
                    2 to 4 hours on the way
                  </Content>
                </ListItem>
                <ListItem>
                  <Content contentKey="can-exlude-cities">
                    Can exclude cities
                  </Content>
                </ListItem>
                <ListItem>
                  <Content contentKey="depart-from-house">
                    Depart from your own home
                  </Content>
                </ListItem>
              </List>
              <ExcludeCities />
            </div>

            <ModalFooter onClose={this.toggleModal} onSave={this.toggleModal} />
          </Modal>
        ) : null}
      </>
    )
  }

  private getExcludedCitiesList = () => {
    if (this.props.excludedCities.length === 0) {
      return (
        <DisplayContent contentKey="no-excluded-cities">
          No excluded cities
        </DisplayContent>
      )
    }
    return this.props.excludedCities.map(x => x.name).join(', ')
  }

  private toggleModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }
}

export default connect((state: AppState) => ({
  excludedCities: state.funnelOrder.excludedCitiesIds,
}))(TrainExcludedOption)
